var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnsuccessIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EC3342"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m44.315 31.375 9.913-9.822c.551-.551.551-1.56 0-2.112l-2.294-2.294c-.551-.551-1.561-.551-2.112 0L40 27.06l-9.914-9.915c-.55-.55-1.56-.55-2.111 0l-2.295 2.295c-.551.551-.551 1.561 0 2.112l9.914 9.822-9.914 9.914c-.551.55-.551 1.56 0 2.111l2.295 2.295c.55.551 1.56.551 2.11 0L40 35.781l9.822 9.914c.551.551 1.56.551 2.112 0l2.294-2.295c.551-.55.551-1.56 0-2.11l-9.913-9.915z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.87451 0 0 0 0 0.227451 0 0 0 0 0.298039 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7606_2483"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7606_2483",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnsuccessIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unsuccess-icon.9c494239e9d94742d9bb2a54521eabc3.svg";